// import external modules
import React, { useEffect, useState } from "react";
// import Navbar from "../components/navbar/navbar";
import Sidebar from "../components/sidebar/sidebar";
import SidebarTrainer from "../components/sidebar/sidebarTrainer";
import { connect, useDispatch, useSelector } from "react-redux";
import { setSidebarStatus } from "../redux/actions/sidebar/sidebarAction";
import PrivateNavBar from "../components/navbar/privateNavBar";
import { CheckinScannerHandler } from "../components/checkingScannerHandler";
import { getExpiringToday } from "../redux/actions/api/apiAction";
import { MembershipCardsScannerPopup } from "../components/membershipCardScanner/MembershipCardsScannerPopup";
import { SubscriptionExpiryPopup } from "../components/subscriptionExpiryPopup";
const AdminLayout = ({ children, props, ...rest }) => {
  const { membershipCardsScannerPopupOpen } = useSelector(state => state.membershipCard);
  const { features } = useSelector(state => state.features);
  const { gymConfig } = useSelector(state => state.gym);
  const dispatch = useDispatch();
  const [role, setRole] = useState();
  const [screenType, setScreenType] = useState(
    window.innerWidth > 1200 ? "normal" : "borken"
  );
  useEffect(() => {
    setRole(JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).role);
    dispatch(getExpiringToday());
  }, [dispatch]);

  return (
    <div>
      <CheckinScannerHandler />
      <SubscriptionExpiryPopup />
      {gymConfig?.gates?.enabled && gymConfig?.gates?.accessBy == "RFIDCards" && membershipCardsScannerPopupOpen && <MembershipCardsScannerPopup/>}
      <main className="admin-panel">
        <div className="navbar-block">
          <PrivateNavBar />
        </div>
        <div className="sidebar-layout-wrapper">
          {role === "GYM" || role === "STAFF" ? (
            <Sidebar broken={screenType === "broken"} />
          ) : (
            <SidebarTrainer />
          )}
          {/* put here condition for trainer info sidebar  */}
        </div>
        <div
          className={`admin-layout-body `}
          style={{
            width:
              screenType === "normal"
                ? rest.collapsed
                  ? "calc(100% - 88px)"
                  : "calc(100% - 300px)"
                : "100%",
            marginLeft:
              screenType === "normal"
                ? rest.collapsed
                  ? "80px"
                  : "300px"
                : "0",
            transition: "500ms",
          }}
          onClick={() => {
            //console.log('i am called');
            dispatch(setSidebarStatus(false));
          }}
        >
          {/* <h1>jekjhdjfhdsjhs</h1> */}
          {children}
        </div>
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { collapsed } = state.sidebar;

  return {
    collapsed,
  };
};

export default connect(mapStateToProps)(AdminLayout);
